var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowsDown = function SvgArrowsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.504 18.347L.855 10.698l.701-.7 6.948 6.947V0h.992v16.945l6.948-6.948.7.701-7.648 7.65v.138h-.14l-.021.022-.19.48L9 18.842l-.145.144-.19-.48-.021-.02h-.14v-.14zm53 0l-7.649-7.649.701-.7 6.948 6.947V0h.992v16.945l6.948-6.948.7.701-7.648 7.65v.138h-.14l-.021.022-.19.48-.145-.145-.145.144-.19-.48-.021-.02h-.14v-.14zm-26 0l-7.649-7.649.701-.7 6.948 6.947V0h.992v16.945l6.948-6.948.7.701-7.648 7.65v.138h-.14l-.021.022-.19.48-.145-.145-.145.144-.19-.48-.021-.02h-.14v-.14z",
    fill: "#000",
    fillRule: "evenodd",
    fillOpacity: 0.38
  })));
};
export default SvgArrowsDown;